<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="artical" [lastPath]="artical.ARTICAL_TITAL"></lifedi-breadcrumb>

<div class="container" *ngIf="artical && suggestArtical">
  <h1>{{artical.ARTICAL_TITAL}}</h1>
  <div class="row justify-content-between">
    <div class="col-12 mb-1">
      <h6>ประเภท : {{artical.ARTICAL_USER.VALUE_TH}}</h6>
      <h6 style="display: inline-block;">จำนวนการอ่าน {{artical.ARTICAL_READED}} ครั้ง</h6>
      <h6 *ngIf="artical.ALWAYS_OPEN === 'true'" style="display: inline-block; float: right;">
        วันที่ {{ artical.ARTICAL_DATE | date }}
      </h6>
      <h6 *ngIf="artical.ALWAYS_OPEN === 'false'" style="display: inline-block; float: right;">
        วันที่ {{ artical.ARTICAL_START | date }}
      </h6>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <img [src]="artical.ARTICAL_PIC" style="width: 100%;">
    </div>
  </div>

  <!-- have suggest artical -->
  <div class="row" *ngIf="suggestArtical.length > 0">
    <div class="col-lg-9 col-md-12 col-sm-12 col-12 mt-4">
      <div [innerHtml]="articalDetails" id="_content"
        style="line-height: 2; width: 100%; background: white; padding: 30px;">
      </div>
      <div *ngIf="poll?.POLL_STATUS === 0 && !poll?.VOTED && isPollTime" class="row mt-4">

        <!-- vote -->
        <div *ngIf="!isVoted" class="col-12 text-center">
          <h5><b>{{ poll.POLL_QUESTION }}</b></h5>
          <form [formGroup]="pollForm">
            <mat-radio-group formControlName="selectedChoice">
              <mat-radio-button class="mr-3" [value]="poll.POLL_CHOICE[0].OPTION_ID">
                {{ poll.POLL_CHOICE[0].OPTION_VALUE }}
              </mat-radio-button>
              <mat-radio-button [value]="poll.POLL_CHOICE[1].OPTION_ID">
                {{ poll.POLL_CHOICE[1].OPTION_VALUE }}
              </mat-radio-button>
            </mat-radio-group>
          </form>
          <div *ngIf="!haveLogin" class="mt-2">
            <a (click)="openLogin()" style="text-decoration: underline;">เข้าสู่ระบบ เพื่อโหวต</a>
          </div>
          <div *ngIf="haveLogin">
            <lifedi-btn *ngIf="pollForm.valid" lable="ส่ง"
              customStyle="color: white; background-color: #3E8C1A; width: 100px;" (click)="vote(pollForm.value)">
            </lifedi-btn>
            <lifedi-btn *ngIf="!pollForm.valid" lable="ส่ง" disabled="true" customStyle="width: 100px;"
              (click)="vote(pollForm.value)">
            </lifedi-btn>
          </div>
        </div>

        <!-- vote success -->
        <div *ngIf="isVoted" class="col-12 text-center mt-3 mb-3">
          <h5><b>ขอบคุณสำหรับการแสดงความคิดเห็น</b></h5>
        </div>
      </div>
      <div *ngIf="artical.ADMIN_CREATEID" class="p-4 mt-4 mb-4" style="background-color: white;">
        <div class="row justify-content-center">
          <img class="profilePic p-2" [src]="artical.ADMIN_CREATEID.IMG">
        </div>
        <div class="row justify-content-center mt-3">
          <h4>{{ artical.ADMIN_CREATEID.USERNAME }}</h4>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-12 col-sm-12 col-12 p-3">
      <h4 class="mt-3">เรื่องที่คุณอาจสนใจ</h4>
      <div class="row">
        <div *ngFor="let item of suggestArtical" class="mt-4 col-lg-12 col-md-6 col-sm-6 col-12">
          <lifedi-card-box (click)="viewSuggest(item.ARTICAL_ID)" [title]="item.ARTICAL_TITAL"
            [imageUrl]="item.ARTICAL_PIC" [content]="item.ARTICAL_DETAIL" [id]="item.ARTICAL_ID" style="outline: none;">
          </lifedi-card-box>
        </div>
      </div>
    </div>
  </div>


  <!-- no suggest artical -->
  <div class="row" *ngIf="suggestArtical.length === 0">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
      <div [innerHtml]="articalDetails" id="_content"
        style="line-height: 2; width: 100%; background: white; padding: 30px;">
      </div>
      <div *ngIf="poll?.POLL_STATUS === 0 && !poll?.VOTED && isPollTime"
        class="row col-lg-12 col-md-12 col-sm-12 col-12 mt-4">

        <!-- vote -->
        <div *ngIf="!isVoted && haveLogin" class="col-12 text-center">
          <h5><b>{{ poll.POLL_QUESTION }}</b></h5>
          <form [formGroup]="pollForm">
            <mat-radio-group formControlName="selectedChoice">
              <mat-radio-button class="mr-3" [value]="poll.POLL_CHOICE[0].OPTION_ID">
                {{ poll.POLL_CHOICE[0].OPTION_VALUE }}
              </mat-radio-button>
              <mat-radio-button [value]="poll.POLL_CHOICE[1].OPTION_ID">
                {{ poll.POLL_CHOICE[1].OPTION_VALUE }}
              </mat-radio-button>
            </mat-radio-group>
          </form>
          <lifedi-btn *ngIf="pollForm.valid" lable="ส่ง"
            customStyle="color: white; background-color: #3E8C1A; width: 100px;" (click)="vote(pollForm.value)">
          </lifedi-btn>
          <lifedi-btn *ngIf="!pollForm.valid" lable="ส่ง" disabled="true" customStyle="width: 100px;"
            (click)="vote(pollForm.value)">
          </lifedi-btn>
        </div>

        <!-- login for vote -->
        <div *ngIf="!haveLogin" class="col-12 text-center mt-2">
          <h4 id="target" class="lifedi-color col-12">เข้าสู่ระบบ เพื่อโหวต</h4>
          <div class="form-group row mt-3 mb-2">
            <lifedi-btn lable="เข้าสู่ระบบ" style="margin: 0 auto;"
              customStyle="color:white; background-color: #414A6B; padding: 0 50px" (click)="openLogin()">
            </lifedi-btn>
          </div>
        </div>

        <!-- vote success -->
        <div *ngIf="isVoted" class="col-12 text-center mt-3 mb-3">
          <h5><b>ขอบคุณสำหรับการแสดงความคิดเห็น</b></h5>
        </div>
      </div>

      <div *ngIf="artical.ADMIN_CREATEID" class="p-4 mt-4 mb-4" style="background-color: white;">
        <div class="row justify-content-center">
          <img class="profilePic p-2" [src]="artical.ADMIN_CREATEID.IMG">
        </div>
        <div class="row justify-content-center mt-3">
          <h4>{{ artical.ADMIN_CREATEID.USERNAME }}</h4>
        </div>
      </div>
    </div>
  </div>
  <br />
</div>
<lifedi-footer *ngIf="artical && suggestArtical"></lifedi-footer>
